import { Box, Container, Typography, Grid, Card, CardContent, Chip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import PeopleIcon from '@mui/icons-material/People';

const services = [
  {
    icon: <RocketLaunchIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
    title: 'SaaS プロダクト開発',
    desc: 'スケーラブルなSaaSプロダクトの設計・開発・運用を提供します。React・Firebase・GCPを中心に、スピーディーにMVPから本番サービスまで構築します。',
    tags: ['React', 'Firebase', 'GCP', 'TypeScript'],
  },
  {
    icon: <AutoAwesomeIcon sx={{ fontSize: 48, color: 'secondary.main' }} />,
    title: 'AI プロダクト開発',
    desc: 'LLMを活用した業務自動化ツール・社内AIアシスタント・RAGシステムの構築。最新のAI技術をプロダクトに組み込み、競争優位性を高めます。',
    tags: ['LLM', 'RAG', 'Claude', 'GPT-4', 'LangChain'],
  },
  {
    icon: <PeopleIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
    title: 'AI 導入コンサルティング',
    desc: '現場の業務フローを分析し、AIで解決できる課題を特定。PoC設計から実装・社内展開まで、現場に根付くAI活用を伴走支援します。',
    tags: ['業務分析', 'PoC', '社内展開', '研修'],
  },
];

export default function Services() {
  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 10, textAlign: 'center' }}>
          <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 4, fontWeight: 700 }}>
            Services
          </Typography>
          <Typography variant="h2" sx={{ mt: 2, fontSize: { xs: '2rem', md: '2.8rem' } }}>
            サービス
          </Typography>
        </Box>

        <Grid container spacing={5}>
          {services.map((s) => (
            <Grid item xs={12} key={s.title}>
              <Card
                elevation={0}
                sx={{
                  p: 2,
                  border: '1px solid rgba(255,255,255,0.08)',
                  transition: 'border-color 0.3s',
                  '&:hover': { borderColor: 'primary.main' },
                }}
              >
                <CardContent>
                  <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={1} sx={{ textAlign: { xs: 'left', md: 'center' } }}>
                      {s.icon}
                    </Grid>
                    <Grid item xs={12} md={11}>
                      <Typography variant="h4" sx={{ mb: 2, fontWeight: 700, fontSize: { xs: '1.5rem', md: '2rem' } }}>
                        {s.title}
                      </Typography>
                      <Typography color="text.secondary" sx={{ mb: 3, lineHeight: 1.9 }}>
                        {s.desc}
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {s.tags.map((tag) => (
                          <Chip
                            key={tag}
                            label={tag}
                            size="small"
                            sx={{ bgcolor: 'rgba(0,229,255,0.08)', color: 'primary.main', border: '1px solid rgba(0,229,255,0.2)' }}
                          />
                        ))}
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
